import { render, staticRenderFns } from "./Investment.vue?vue&type=template&id=fd6f8218&scoped=true&"
import script from "./Investment.vue?vue&type=script&lang=js&"
export * from "./Investment.vue?vue&type=script&lang=js&"
import style0 from "./Investment.vue?vue&type=style&index=0&id=fd6f8218&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd6f8218",
  null
  
)

export default component.exports